import axios from 'axios';
import { getToken } from '@/utils/store';

// 创建 Axios 实例
const service = axios.create({
  // baseURL: 'http://47.76.228.16/api/', // 设置 API 的基础 URL
  baseURL:'https://www.kkama.vip/api',
  // baseURL:'http://192.168.0.4:8000/',
  timeout: 115000, // 请求超时时间
});

const no_token = ['/strategy/api/strategies']; // 无需 token 的接口
function containsAny(str, arr) {
  return arr.some(element => str.includes(element));
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = getToken("token");
    const result = containsAny(config.url, no_token); // 获取token接口返回 true
    if (token) {
      if (!result) {
        config.headers = {
          Authorization: "Bearer " + token,
        };
      }
      // 这里对Content-Type进行控制
      if (config.url !== '/ckeditor/upload/') {
        config.headers['Content-Type'] = 'application/json';
      }
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果响应数据是二进制数据，处理流
    if (response.headers['content-type'] && response.headers['content-type'].includes('application/octet-stream')) {
      // 处理二进制流
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        // 将响应的二进制数据（blob）读取为ArrayBuffer
        reader.onloadend = () => {
          const arrayBuffer = reader.result;
          resolve(arrayBuffer); // 返回二进制数据
        };

        // 处理读取错误
        reader.onerror = () => {
          reject(new Error('Failed to read binary data'));
        };

        // 读取响应数据
        reader.readAsArrayBuffer(response.data);
      });
    } else {
      // 如果是普通的JSON数据，则直接返回
      return response.data;
    }
  },
  error => {
    // 对响应错误做些什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.log('用户名密码错误');
          break;
        case 404:
          console.error('请求的资源不存在');
          break;
        default:
          console.error('请求失败', error.response.data);
      }
    } else if (error.request) {
      console.error('请求超时或网络错误', error.request);
    } else {
      console.error('请求配置错误', error.message);
    }
    return Promise.reject(error);
  }
);

export default service;

